$(document).foundation()

jQuery(document).ready(function($) {

  // on scroll change header class
  if ($('.hero-top, .hero-home').length > 0) {
    $(window).on('scroll', function() {
      if ($(window).scrollTop() > $(window).height() / 2) {
        $('header').removeClass('transparent')
      } else {
        $('header').addClass('transparent')
      }
    })
  }

  // load and show thumbnails
  var offsetAmount = '100%'
  $('.work-thumbnails a').each(function() {
    $(this).waypoint(function(direction) {
      var $thumbnail = $(this.element)
      var $span = $thumbnail.find('span.image')
      $span.css({
        backgroundImage: 'url(' + $span.data('background-image') + ')'
      })
      $thumbnail.imagesLoaded( { background: 'span' }, function() {
        $thumbnail.addClass('is-done-loading')
      })
      this.destroy()
    }, {
      offset: offsetAmount
    })
  })

  // work filters
  $('.work-filters button.current').on('click', function() {
    $('.work-filters').toggleClass('work-filters--is-open')
  })

  // work filters tabindexing
  $('.filters-links a').on('focus', function(e) {
    $('.work-filters').addClass('work-filters--is-open')
  })
  $('.filters-links a').on('blur', function() {
    $('.work-filters').removeClass('work-filters--is-open')
  })

  // mobile menu
  $('.mobile-toggle, .mobile-toggle-white').on('click', function() {
    $('body').toggleClass('mobile-menu--is-showing')
  })

	$(window).on("load", function() {
    // scroll to hashed element if requested
    if (window.location.hash) {
      var hash = window.location.hash.substring(1);
      if (hash) {
        var section = $("#"+hash);
        if (section) {
          $('html,body').animate({scrollTop: section.offset().top - $("header").outerHeight() - 32}, 400);
        }
      }
		}
	});

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  })

  // debugger
  $(window).on('resize', function() {
    $('.debugger .column-width').html($('.debugger .cell').eq(0).width())
    $('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
    $('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
    $('.debugger ')
    // set main's height to fit in windows, in case of too few content
    var mainHeight = $(window).height() - $('footer').outerHeight() - $('header').outerHeight();
    $('main').css('min-height', mainHeight);
  }).trigger('resize')

  $('.debugger').on('click', function(e) {
    $(this).remove()
  })

})
